import { render, staticRenderFns } from "./MrzData.vue?vue&type=template&id=059e4f5c&scoped=true"
import script from "./MrzData.vue?vue&type=script&lang=js"
export * from "./MrzData.vue?vue&type=script&lang=js"
import style0 from "./MrzData.vue?vue&type=style&index=0&id=059e4f5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059e4f5c",
  null
  
)

export default component.exports